import { render, staticRenderFns } from "./PensionService.vue?vue&type=template&id=3ec50e22&"
import script from "./PensionService.vue?vue&type=script&lang=js&"
export * from "./PensionService.vue?vue&type=script&lang=js&"
import style0 from "./PensionService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports